'use client'

import i18next from 'i18next'
import resourcesToBackend from 'i18next-resources-to-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { I18nextProvider as Provider, initReactI18next } from 'react-i18next'
import type { LanguageValue } from './locales-config'
import { i18nOptions } from './locales-config'
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ReactNode, useMemo } from 'react'

// --------------------------------------------------------------------------------------------- //

const init = { ...i18nOptions(), detection: { caches: ['cookie'] } }

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .use(resourcesToBackend((lang: string, ns: string) => import(`./langs/${lang}/${ns}.json`)))
  .init(init)

// --------------------------------------------------------------------------------------------- //

type Props = {
  lang?: LanguageValue | undefined
  children: ReactNode
}

export function I18nProvider({ lang, children }: Props) {
  useMemo(() => {
    if (lang) {
      i18next.changeLanguage(lang)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <Provider i18n={i18next}>{children}</Provider>
}
